import debounce from "lodash/debounce";
export default {
    data() {
        return {
            valid: {
                minimum_amount: false,
                maximum_amount: false,
                // multiplier: false,
                expiration_days: false,
                valid_days_before: false,
                title: false,
                description: false,
            },
            success: {
                minimum_amount: false,
                maximum_amount: false,
                // multiplier: false,
                expiration_days: false,
                valid_days_before: false,
                title: false,
                description: false
            },
            error: {
                minimum_amount: "",
                maximum_amount: "",
                // multiplier: "",
                expiration_days: "",
                valid_days_before: "",
                title: "",
                description: ""
            },
            errorMessages: {
                minimumAmountRequired: {
                    el: "Προσθέστε το ελάχιστο ποσό για αυτό το πακέτο",
                    en:
                        "Please add the minimum amount for this package.",
                    it:
                        "Si prega di aggiungere l'importo minimo  per questo pacchetto."
                },
                minimumAmountGreaterThan100: {
                    el: "Αυτός ο αριθμός δεν μπορεί να είναι μικρότερος του 100",
                    en:
                        "This number cannot be less than 100",
                    it:
                        "Questo numero non può essere inferiore a 100"
                },
                minimumAmountExceededFrom: {
                    el:
                        "Ο ελάχιστος αριθμός πρέπει να είναι μεγαλύτερος από τον ελάχιστο αριθμό της προηγούμενης βαθμίδας",
                    en:
                        "This number must be greater than the minimum number of the previous tier",
                    it:
                        "Questo numero non può essere inferiore al numero minimo del livello precedente"
                },
                minimumAmountExceededTo: {
                    el:
                        "Ο αριθμός αυτός πρέπει να είναι μικρότερος από τον μέγιστο αριθμό πόντων της βαθμίδας του",
                    en:
                        "This number must be less than the tier's maximum number of points",
                    it:
                        "Questo numero deve essere inferiore al numero massimo di punti del livello"
                },
                maximumAmountRequired: {
                    el:
                        "Προσθέστε το μέγιστο αριθμό πόντων για αυτό το πακέτο.",
                    en:
                        "Please add the maximum amount of points for this package.",
                    it:
                        "Si prega di aggiungere l'importo massimo di punti per questo pacchetto"
                },
                maximumAmountExceededFrom: {
                    el:
                        "Ο μέγιστος αριθμός πρέπει να είναι μεγαλύτερος από τον ελάχιστο αριθμό αριθμό πόντων της βαθμίδας του",
                    en:
                        "This number must be greater than the tier's minimum number of points",
                    it:
                        "Questo numero deve essere superiore al numero minimo di punti previsto dal livello"
                },
                maximumAmountExceededTo: {
                    el:
                        "Ο μέγιστος αριθμός πρέπει να είναι μικρότερος από τον μέγιστο αριθμό της επόμενης βαθμίδας",
                    en:
                        "This number cannot exceed the maximum number of the next tier",
                    it:
                        "Questo numero non può superare il numero massimo del livello successivo"
                },
                multiplierRequired: {
                    el:
                        "Προσθέστε το πολλαπλασιαστή πόντων για αυτό το πακέτο.",
                    en: "Please add the point multiplier for this package.",
                    it:
                        "Si prega di aggiungere il moltiplicatore di punti per questo pacchetto."
                },
                multiplierNaN: {
                    el: "Mη έγκυρη τιμή",
                    en: "Invalid value",
                    it: "Valore non valido"
                },
                titleRequired: {
                    el: "Προσθέστε έναν τίτλο για αυτό το πακέτο.",
                    en: "Please add a title for this package.",
                    it: "Aggiungi un titolo per questo pacchetto."
                },
                descriptionRequired: {
                    el: "Προσθέστε μια περιγραφή για αυτό το πακέτο.",
                    en: "Please add a description for this package.",
                    it: "Aggiungi una descrizione per questo pacchetto."
                },
                expirationDaysRequired: {
                    el: "Προσθέστε ημέρες λήξεως επιπέδου.",
                    en: "Please add the tier's expiration days.",
                    it: "Aggiungere i giorni di scadenza del livello."
                },
                countableDaysRequired: {
                    el: "Προσθέστε έγκυρο αριθμό ημερών υπολογίσιμων συναλλαγών επιπέδου.",
                    en: "Please add a valid number for the tier's Countable transactions days.",
                    it: "Aggiungere un numero valido per i giorni di transazioni conteggiabili del livello."
                },
            }
        };
    },

    computed: {
        
        formValid() {
            return  this.valid.minimum_amount &&
                      this.valid.maximum_amount &&
                      this.valid.expiration_days &&
                      this.valid.valid_days_before &&
                    //   this.valid.multiplier &&
                      this.valid.title &&
                      this.valid.description;
        }
    },

    methods: {
        
        validateTierForm(){
            console.log('validateTierForm')
                this.validateTitle()
                this.validateDescription()
                this.validateMinimumAmount()
                this.validateMaximumAmount()
                this.validateExpirationDays()
                this.validateCountableDays()
            return this.formValid
        },
        validateMinimumAmount() {
            this.valid.minimum_amount=false
            if(this.tierIndex === 0){
                this.tiers[this.tierIndex].from = 0
                this.tiers[this.tierIndex]?.pointRange?.[0] && (this.tiers[this.tierIndex].pointRange[0] = 0)
                this.valid.minimum_amount=true

            }else if (!this.tierData.from ) {
                this.error.minimum_amount = this.errorMessages.minimumAmountRequired[
                    this.lang
                ];
            } else if (
                // this.tiers[this.tierIndex - 1] &&
                this.tierData.from <= this.tiers[this.tierIndex - 1].from + 1
            ) {
                this.tiers[this.tierIndex - 1].to =
                    this.tiers[this.tierIndex - 1].from + 1;
                    this.tiers[this.tierIndex - 1]?.pointRange?.[1] && 
                    (this.tiers[this.tierIndex - 1].pointRange[1] = this.tiers[this.tierIndex - 1].from + 1);
                this.tiers[this.tierIndex].from =
                    this.tiers[this.tierIndex - 1].to + 1;
                    this.tiers[this.tierIndex]?.pointRange?.[0] && (this.tiers[this.tierIndex].pointRange[0] =
                    this.tiers[this.tierIndex - 1].to + 1);

                this.error.minimum_amount =
                    this.errorMessages.minimumAmountExceededFrom[this.lang] +
                    ": " +
                    (this.tiers[this.tierIndex - 1].to + 1);
                    this.valid.minimum_amount = true
            } else if (
                this.tiers[this.tierIndex + 1] && this.tierData.to &&
                this.tierData.from >= this.tierData.to
            ) {
                this.tierData.from = this.tierData.to - 1;
                this.tiers[this.tierIndex]?.pointRange?.[0] && (this.tiers[this.tierIndex].pointRange[0] = this.tierData.to - 1);

                this.error.minimum_amount =
                    this.errorMessages.minimumAmountExceededTo[this.lang] +
                    ": " +
                    this.tierData.to;
                    this.valid.minimum_amount = true

            } else {
                if (!this.tiers[this.tierIndex + 1]) {
                    this.tiers[this.tierIndex].to =
                        parseInt(this.tierData.from * this.$props.infinityMultiplier);
                    this.tiers[this.tierIndex]?.pointRange?.[0] && (this.tiers[this.tierIndex].pointRange[1] = this.tiers[
                        this.tierIndex
                    ].to);
                }
                this.error.minimum_amount = "";
                this.tiers[this.tierIndex]?.pointRange?.[0] && (this.tiers[this.tierIndex].pointRange[0] = parseInt(
                    this.tierData.from
                ));
                if (this.tiers[this.tierIndex - 1]) {
                    this.tiers[this.tierIndex - 1].to =
                        parseInt(this.tierData.from) - 1;
                    this.tiers[this.tierIndex - 1].pointRange[1] =
                        parseInt(this.tierData.from) - 1;
                }
                this.valid.minimum_amount = true

            }
        },

        validateMaximumAmount() {
            this.valid.maximum_amount=false
            this.tierData.to = this.tierData.to && parseInt(this.tierData.to);
            if (!this.tierData.to) {
                if(this.tierIndex < (this.tiers.length-1)){
                    this.error.maximum_amount = this.errorMessages.maximumAmountRequired[
                        this.lang
                    ];
                }
            } else if (
                this.tiers[this.tierIndex + 1] &&
                this.tierData.to >= this.tiers[this.tierIndex + 1].to - 1
            ) {
                if (this.tierIndex >= this.tiers.length - 2) {
                    this.tiers[this.tierIndex + 1].to =
                        parseInt((1 + this.tierData.to) *
                                this.$props.infinityMultiplier);
                    this.tiers[this.tierIndex + 1].pointRange[1] = this.tiers[
                        this.tierIndex + 1
                    ].to;
                    this.tiers[this.tierIndex + 1].from = this.tierData.to + 1;
                    this.tiers[this.tierIndex + 1].pointRange[0] =
                        this.tierData.to + 1;
                    this.tiers[this.tierIndex].to = this.tierData.to;
                    this.tiers[this.tierIndex]?.pointRange?.[0] && (this.tiers[this.tierIndex].pointRange[1] = this.tierData.to);
                } else {
                    this.error.maximum_amount =
                        this.errorMessages.maximumAmountExceededTo[this.lang] +
                        ": " +
                        this.tierData.to;
                    this.tiers[this.tierIndex + 1].from =
                        this.tiers[this.tierIndex + 1].to - 1;
                    this.tiers[this.tierIndex + 1].pointRange[0] =
                        this.tiers[this.tierIndex + 1].to - 1;
                    this.tiers[this.tierIndex].to =
                        this.tiers[this.tierIndex + 1].from - 1;
                    this.tiers[this.tierIndex]?.pointRange?.[0] && (this.tiers[this.tierIndex].pointRange[1] =
                        this.tiers[this.tierIndex + 1].from - 1);
                }
                this.valid.maximum_amount = true

            } else if (this.tierData.to <= this.tierData.from) {
                this.error.maximum_amount =
                    this.errorMessages.maximumAmountExceededFrom[this.lang] +
                    ": " +
                    this.tierData.to;
                this.valid.maximum_amount = true
            } else {
                this.error.maximum_amount = "";
                this.tiers[this.tierIndex]?.pointRange?.[0] && (this.tiers[this.tierIndex].pointRange[1] = parseInt(
                    this.tierData.to
                ));
                if (this.tiers[this.tierIndex + 1]) {
                    this.tiers[this.tierIndex + 1].from =
                        parseInt(this.tierData.to) + 1;
                    this.tiers[this.tierIndex + 1].pointRange[0] =
                        parseInt(this.tierData.to) + 1;
                }
                this.valid.maximum_amount = true
            }
        },

        validateMultiplier() {
            this.tierData.multiplier = "" + this.tierData.multiplier.replace(",", ".");
            if (!this.tierData.multiplier) {
                this.error.multiplier = this.errorMessages.multiplierRequired[
                    this.lang
                ];
            } else if (Number.isNaN(Number(this.tierData.multiplier))) {
                this.error.multiplier = this.errorMessages.multiplierNaN[
                    this.lang
                ];
            } else {
                this.error.multiplier = null;
            }
        },

        validateExpirationDays() {
            this.valid.expiration_days=this.tiers_settings.system!=='expiration_mode' || this.tierIndex === 0
            if (
                this.tiers_settings.system==='expiration_mode' &&
                this.tierData.expiration_days <= 0
            ) {
                this.tierData.expiration_days =  this.tierIndex === 0 ? 1 : this.tierData.expiration_days;
                this.error.expiration_days = this.errorMessages.expirationDaysRequired[this.lang];
            } else {
                this.error.expiration_days = "";
                this.valid.expiration_days = true
            }
        },

        validateCountableDays() {
            // this.valid.valid_days_before = this.tiers_settings.tier_mode_id !== 2
            try {
                if (
                    this.tiers_settings.system == 'expiration_mode' &&
                   this.tierData.valid_days_before !== null && 
                   (Number.isNaN(Number(this.tierData.valid_days_before) || this.tierData.valid_days_before < 0))
                   
                ) {
                    this.error.valid_days_before = this.errorMessages.countableDaysRequired[this.lang];
                } else {
                    this.error.valid_days_before = "";
                    this.valid.valid_days_before = true
                }
            } catch (error) {
                this.error.valid_days_before = this.errorMessages.countableDaysRequired[this.lang];
                this.valid.valid_days_before = false
                this.success.valid_days_before = false
            }
           
        },

        validateTitle() {
            this.valid.title=false
            if (
                !this.tierData.title.en ||
                !this.tierData.title.el ||
                !this.tierData.title.it
            ) {
                this.error.title = this.errorMessages.titleRequired[this.lang];
            } else {
                this.error.title = "";
                this.valid.title = true

            }
        },

        validateDescription() {
            this.valid.description = false
            if (
                !this.tierData.description.en ||
                !this.tierData.description.el ||
                !this.tierData.description.it
            ) {
                this.error.description = this.errorMessages.descriptionRequired[
                    this.lang
                ];
            } else {
                this.error.description = "";
                this.valid.description = true
            }
        }
    },

    watch: {
        ["tier.from"]: {
            immediate: true,
            handler(val) {
                if(this.tierIndex > 0){
                    this.valid.minimum_amount = !!val;
                    this.success.minimum_amount = !!val;
                }
            }
        },

        ["tier.to"]: {
            immediate: true,
            handler(val) {
                this.valid.maximum_amount = !!val;
                this.success.maximum_amount = !!val;
            }
        },

        // ["tier.multiplier"]: {
        //     immediate: true,
        //     handler(val) {
        //         this.valid.multiplier = !!val;
        //         this.success.multiplier = !!val;
        //     }
        // },

        ["tier.expiration_days"]: {
            immediate: true,
            handler(val) {
                this.valid.expiration_days = val>0 || this.tiers_settings.system!=='expiration_mode' || this.tierIndex === 0;
                this.success.expiration_days = val>0 || this.tiers_settings.system!=='expiration_mode' || this.tierIndex === 0;
            }
        },
        
        ["tier.valid_days_before"]: {
            immediate: true,
            handler(val) {
                try {
                    this.valid.valid_days_before = (val)>=0 || val===null || this.tiers_settings.system!=='expiration_mode';
                    this.success.valid_days_before = (val)>=0 || val===null || this.tiers_settings.system!=='expiration_mode';
                } catch (error) {
                    this.valid.valid_days_before = false
                    this.success.valid_days_before = false
                }
            }
        },

        ["tier.title"]: {
            deep: true,
            handler(val) {
                this.valid.title = !!(val.en || val.el || val.it);
                this.success.title = !!(val.en || val.el || val.it);
            }
        },

        ["tier.description"]: {
            deep: true,
            handler(val) {
                this.valid.description = !!(val.en || val.el || val.it);
                this.success.description = !!(val.en || val.el || val.it);
            }
        },


        resetSuccess(val) {
            if (val) {
                this.success = {
                    minimum_amount: false,
                    maximum_amount: false,
                    // multiplier: false,
                    expiration_days: false,
                    valid_days_before: false,
                    title: false,
                    description: false
                };

                this.setResetSuccess(false);
            }
        },

        resetValidation: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.error = {
                        minimum_amount: "",
                        maximum_amount: "",
                        // multiplier: "",
                        expiration_days: "",
                        valid_days_before:"",
                        title: "",
                        description: ""
                    };

                    this.setResetValidation(false);
                }
            }
        }
    },
    created() {
        this.debouncedValidation = debounce(this.validateTierForm, 800);
    },
};
